/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const createPageOverlayStyles = makeStyles((theme: Theme) => ({
  modal: {
    padding: theme.spacing(1),
    paddingBottom: '15px',
    overflowY: 'auto',
    display: 'flex',
    backgroundColor: 'rgba(255, 255, 255, 0.61)',
  },
  paper: {
    margin: '0 auto',
    display: 'flex',
    maxWidth: '992px',
    width: '100%',
    '&:focus': {
      outline: 0,
    },
    paddingTop: '30px',
    zIndex: 1,
  },
  buttonsBlock: {
    flex: '0 0 48px',
  },
  buttonsBlockInner: {
    '&$fixed': {
      position: 'fixed',
      top: '15px',
    },
  },
  fixed: {},
  childrenBlock: {
    flex: 1,
    // paddingTop: "10px",
  },
}));

export const backdropStyles = { backgroundColor: 'rgba(255, 255, 255, 0.61)' };
